import SegmentedBar from '@/components/ui/SegmentedBar.tsx';
import { STATUS_TONE_COLORS } from '@/components/ui/statusTone.ts';
import { AvailabilityFieldDto } from '@/features/dashboard/tours/types/AvailabilityFieldDto.ts';
import { occupancyPercent } from '@/features/dashboard/tours/types/availability.utils.ts';
import { getOptionOccupancyStatusDisplay } from '@/features/dashboard/tours/types/dashboard/optionOccupancyStatus.utils.ts';

interface OccupancyBarProps extends React.HTMLAttributes<HTMLDivElement> {
  availability: AvailabilityFieldDto;
}

/**
 * Pasek zajętych miejsc w barwie stanu — ta sama informacja co kropka obok,
 * tyle że mierzalna. Bez limitu nie ma czego malować, więc paska nie ma wcale.
 */
const OccupancyBar = ({ availability, ...props }: OccupancyBarProps) => {
  const percent = occupancyPercent(availability);
  if (percent === null) return null;

  const { tone } = getOptionOccupancyStatusDisplay(availability);

  return (
    <SegmentedBar
      segments={[
        { id: 'taken', pct: percent, color: STATUS_TONE_COLORS[tone].dot },
      ]}
      {...props}
    />
  );
};

export default OccupancyBar;
